module.exports = __webpack_public_path__ + "static/flyer-ec0cdb1d096520bf9b9adec96b7709a8.pdf";